import { render, staticRenderFns } from "./rel-ba.vue?vue&type=template&id=3f9242a2&scoped=true&"
import script from "./rel-ba.vue?vue&type=script&lang=js&"
export * from "./rel-ba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9242a2",
  null
  
)

export default component.exports